import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseHttpService } from '../http/base.http.service';
import { ApiRouterService } from '../http/api.router';
import { FareType } from 'src/app/models/enums';

@Injectable({
  providedIn: 'root',
})
export class FaresHttpService extends BaseHttpService {
  private baseURL = `fares`;

  constructor(
    @Inject(HttpClient) httpClient: HttpClient,
    private routerService: ApiRouterService,
  ) {
    super(httpClient);
  }

  private getFareTypePath(type: FareType): string {
    switch (type) {
      case FareType.Basic:
        return 'basic';
      case FareType.Flexible:
        return 'flexible';
      case FareType.Ranged_Flexible:
        return 'ranged-flexible';
      case FareType.Zonal:
        return 'zonal';
      default:
        return 'basic';
    }
  }

  public getFares(clientId: number, size?: number, page?: number, name?: string, includeInactive?: boolean) {
    let path = '';
    const params: string[] = [];
    if (size !== undefined) params.push(`size=${size}`);
    if (page !== undefined) params.push(`page=${page}`);
    if (name !== undefined && name !== '') params.push(`name=${encodeURIComponent(name)}`);
    if (includeInactive) params.push(`includeInactive=true`);
    if (params.length > 0) path = `?${params.join('&')}`;
    const url = this.routerService.mount(`${this.baseURL}/client/${clientId}${path}`);
    return this.read(url);
  }

  private extractId(id: any): number {
    if (typeof id === 'number') return id;
    if (typeof id === 'object' && id !== null && 'id' in id) return this.extractId(id.id);
    return Number(id);
  }

  public getFare(id: any, type: FareType) {
    const numericId = this.extractId(id);
    const typePath = this.getFareTypePath(type);
    const url = this.routerService.mount(`${this.baseURL}/${typePath}/${numericId}`);
    return this.read(url);
  }

  public createFare(fare: any, type: FareType) {
    const typePath = this.getFareTypePath(type);
    const url = this.routerService.mount(`${this.baseURL}/${typePath}`);
    return this.create(fare, url);
  }

  public updateFare(id: any, fare: any, type: FareType) {
    const numericId = this.extractId(id);
    const typePath = this.getFareTypePath(type);
    const url = this.routerService.mount(`${this.baseURL}/${typePath}`);
    return this.update(fare, url);
  }

  public deactivateFare(id: any) {
    const numericId = this.extractId(id);
    const url = this.routerService.mount(`${this.baseURL}/${numericId}/deactivate`);
    return this.update({}, url);
  }

  public activateFare(id: any) {
    const numericId = this.extractId(id);
    const url = this.routerService.mount(`${this.baseURL}/${numericId}/activate`);
    return this.update({}, url);
  }
}
